import axios from "axios";

axios.defaults.withCredentials = true;

const readAxiosInstance = axios.create({
  //baseURL: "https://dv3.pesa.solutions/api/",
  //baseURL: "http://localhost:5050/api/",
});

const writeAxiosInstance = axios.create({
  baseURL: "https://dv3.pesa.solutions/api/",
  //baseURL: "http://localhost:5050/api/",
});

const axiosInstances = {
  read: readAxiosInstance,
  write: writeAxiosInstance,
};

export default axiosInstances;